'use strict';

var keyMirror = require('keymirror');

module.exports = {
	PayloadSources: keyMirror({
		SERVER_ACTION: null,
		VIEW_ACTION: null
	})
};